import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { IconNames } from 'atoms/Icon'
import { COLOR } from 'vars/color'
import { INDENTS } from 'vars/indents'
import { Button } from '../Button'
import {
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFluid,
  ButtonFonts,
  ButtonIconSizes,
} from '../Button.h'

export interface IInlineBrandButtonProps extends IButtonProps {}

export const InlineBrandButton = ({
  icon = IconNames.setplex,
  iconSize = ButtonIconSizes.medium,
  corners = ButtonCorners.CORNERS_10,
  paddings = [INDENTS.INDENT_40],
  colorDefault = ButtonColors.COLOR_PRIMARY,
  backgroundColorDefault = COLOR.TRANSPARENT,
  backgroundColorDisabled = COLOR.TRANSPARENT,
  borderWidth = ButtonBordersWidth.BORDER_0,
  font = ButtonFonts.Button1,
  fluid = ButtonFluid.None,
  ...rest
}: IInlineBrandButtonProps): JSX.Element => {
  return (
    <Button
      icon={icon}
      iconSize={iconSize}
      corners={corners}
      paddings={paddings}
      colorDefault={colorDefault}
      backgroundColorDefault={backgroundColorDefault}
      backgroundColorDisabled={backgroundColorDisabled}
      borderWidth={borderWidth}
      font={font}
      fluid={fluid}
      {...rest}
    />
  )
}
